export default __webpack_public_path__ + "images/192x192.png";